import { css } from '@emotion/react'
import { bool, object } from 'prop-types'

import Rating from '@/components/Rating'
import Badges from '../Badges'
import Designation from '../Designation'
import DevelopedBy from '../DevelopedBy'
import Payment from '../Payment'

const infoBottomPartCss = css`
  display: flex;
  margin-top: 5px;
  width: 100%;
  flex-wrap: wrap;
  gap: 5px 16px;
`

const AdditionalInfo = ({
  product,
  rating,
  isTutorialApplication,
  isService,
  developer,
  isCompact,
}) => {
  const { payment, id, product: designation } = product
  return (
    <>
      {payment && <Payment isCompact={isCompact} payment={payment} />}

      <Badges id={id} />

      <div css={infoBottomPartCss}>
        {!isTutorialApplication && rating && (
          <Rating
            {...rating}
            canVote
            starsCount={1}
            showVotes={false}
            developer={developer}
          />
        )}
        {!isTutorialApplication && developer?.company && (
          <DevelopedBy developer={developer} isService={isService} />
        )}

        <Designation product={designation} />
      </div>
    </>
  )
}

AdditionalInfo.propTypes = {
  product: object,
  isRatingFetched: bool,
  rating: object,
  isVerifiedApp: bool,
  developer: object,
  isTutorialApplication: bool,
  isCompact: bool,
  isService: bool,
}

export default AdditionalInfo
